module.exports = __webpack_public_path__ + "img/symbol-five-thirds-center.34db4167.png";